import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/icon/success.svg'


const _hoisted_1 = {
  key: 0,
  class: "payment-success"
}
const _hoisted_2 = { class: "payment-success__wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "loader"
}
const _hoisted_5 = { class: "menu-wrapper" }

import { IonApp, IonSpinner, IonFooter, IonContent } from '@ionic/vue'
import { useAppStore } from '@/state/app'
import BrandLogo from './components/icons/BrandLogo.vue'
import StoreIcon from './components/icons/StoreIcon.vue'
import PaymentIcon from './components/icons/PaymentIcon.vue'
import AccountIcon from './components/icons/AccountIcon.vue'
import OrderIcon from './components/icons/OrderIcon.vue'

import { useCustomerStore } from '@/state/customer'
import VMenuButton from '@/components/shared/VMenuButton.vue'
import { storeToRefs } from 'pinia'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const app = useAppStore()
const { isShowingPaymentSuccess } = storeToRefs(app)
const auth = useCustomerStore()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      (_unref(isShowingPaymentSuccess))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(BrandLogo, { class: "logo" }),
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("h1", null, _toDisplayString(_ctx.$t('common.successfulPayment')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(app).isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(BrandLogo, { class: "logo" }),
            _createVNode(_unref(IonSpinner), { name: "crescent" })
          ]))
        : (_openBlock(), _createBlock(_unref(IonContent), { key: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view, null, {
                default: _withCtx(({ Component, route }) => [
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                        key: route.path
                      }))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
      (
        _unref(auth).isAuthenticated &&
        !_unref(app).isLoading &&
        !['SignIn', 'SignUp', 'Splash', 'AgeVerification', 'EditCustomer', 'Instruction', 'Tos', 'Privacy'].includes(_ctx.$route.name as string)
      )
        ? (_openBlock(), _createBlock(_unref(IonFooter), {
            key: 3,
            class: "ion-no-border"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(VMenuButton, {
                  active: _ctx.$route.name === 'Store',
                  label: _ctx.$t('menu.inStore'),
                  onNavigate: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'Store' })))
                }, {
                  default: _withCtx(() => [
                    _createVNode(StoreIcon)
                  ]),
                  _: 1
                }, 8, ["active", "label"]),
                _createVNode(VMenuButton, {
                  label: _ctx.$t('menu.orders'),
                  active: _ctx.$route.name === 'Orders',
                  icon: require('@/assets/icon/orders.svg'),
                  onNavigate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'Orders' })))
                }, {
                  default: _withCtx(() => [
                    _createVNode(OrderIcon)
                  ]),
                  _: 1
                }, 8, ["label", "active", "icon"]),
                _createVNode(VMenuButton, {
                  label: _ctx.$t('menu.payment'),
                  active: _ctx.$route.name === 'Payment' || _ctx.$route.name === 'AddPayment',
                  icon: require('@/assets/icon/payment.svg'),
                  onNavigate: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'Payment' })))
                }, {
                  default: _withCtx(() => [
                    _createVNode(PaymentIcon)
                  ]),
                  _: 1
                }, 8, ["label", "active", "icon"]),
                _createVNode(VMenuButton, {
                  active: _ctx.$route.name === 'Account',
                  label: _ctx.$t('menu.account'),
                  icon: require('@/assets/icon/account.svg'),
                  onNavigate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'Account' })))
                }, {
                  default: _withCtx(() => [
                    _createVNode(AccountIcon)
                  ]),
                  _: 1
                }, 8, ["active", "label", "icon"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})